import {
    Dialog,
    handleClose,
    useParams,
} from "@compass/core";
import { Student } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { StudentQrPageHeader } from "./StudentQrPageHeader";
import { StudentQrPageBody } from "./StudentQrPageBody";
import ApiService from "services/apiService";

const routeName = "studentQr";

class Params {
    studentId: number = 0;
}

export const StudentQrPage = () => {
    const { params } = useParams(routeName, Params);
    const navigate = useNavigate();
    const { state } = useLocation();
    const [student, setStudent] = useState<Student>({} as Student);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (state?.student) {
            // Use student data passed from BasicInfo
            setStudent(state.student);
        } else {
            loadStudent();
        }
    }, [params.studentId, state]);

    const loadStudent = async () => {
        try {
            const response = await ApiService.students.get(params.studentId);
            setStudent(response);
        } catch (error) {
            console.error('Failed to load student:', error);
        }
    };

    const updateStudent = (updater: (draft: Student) => void) => {
        const updatedStudent = produce(student, updater);
        setStudent(updatedStudent);
    };

    return (
        <Dialog
            open={true}
            onClose={() => handleClose(navigate)}
            maxWidth="sm"
            header={<StudentQrPageHeader student={student} />}
            content={
                <StudentQrPageBody
                    student={student}
                    setStudent={updateStudent}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            }
        />
    );
};